import { inject, Pipe, PipeTransform } from '@angular/core';
import { UserContext, config, MemberQuery } from '@fgb/core';

/**
 * Transforms a relative asset path into a full ContentAssets URL for the current user's club and locale.
 *
 * @example
 * // In a template:
 * // 'images/account-icon.svg' | contentAssetImage
 * // => 'https://devportal.fortressgb.com/ContentAssets/assets/1/0/images/account-icon.svg'
 *
 * // 'documents/terms.pdf' | contentAssetImage
 * // => 'https://devportal.fortressgb.com/ContentAssets/assets/1/0/documents/terms.pdf'
 */
@Pipe({ name: 'contentAssetImage' })
export class ContentAssetImagePipe implements PipeTransform {
  private memberQuery = inject(MemberQuery);

  transform(value: string): string {
    if (!value) {
      return `${config.contentUrl}/images/noimage.png`;
    }

    if (value.includes('http')) {
      return value;
    }

    const currentUser =
      this.memberQuery.getValue().user || ({ clubId: config.defaultClubId, lcid: config.defaultLcid } as UserContext);

    return `${config.contentUrl}/assets/${currentUser.clubId}/${currentUser.lcid}/${value}`;
  }
}
